import { Link } from "react-router-dom";
import { motion } from "framer-motion";

export default function BookCard({ book, index = 0 }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5, delay: index * 0.08 }}
      data-testid={`book-card-${book.slug}`}
    >
      <Link to={`/books/${book.slug}`} className="group block">
        <div className="relative overflow-hidden border border-zinc-800/60 bg-zinc-900/40 aspect-square">
          <img
            src={book.cover_image}
            alt={book.title}
            className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-zinc-950 via-transparent to-transparent opacity-60" />
          <span className="absolute top-3 left-3 bg-zinc-950/80 backdrop-blur px-2 py-1 text-[10px] tracking-accent uppercase text-amber-500 border border-zinc-800">
            {book.coming_soon ? "Coming Soon" : book.genre}
          </span>
        </div>
        <div className="pt-4">
          {book.series && <p className="text-[11px] tracking-accent uppercase text-zinc-500 mb-1">{book.series}</p>}
          <h3 className="font-display text-xl font-semibold group-hover:text-amber-500 transition-colors">{book.title}</h3>
          <p className="text-sm text-zinc-500 mt-1 line-clamp-2">{book.tagline}</p>
        </div>
      </Link>
    </motion.div>
  );
}
